module.exports = __webpack_public_path__ + "img/gold_vee_spot.5db03cf6.svg";